enum GridappBuildStatusEnum {
  PROCESSING = 'processing',
  DRAFT = 'draft',
  ERROR = 'error',
  PUBLISHED = 'published',
}

export default GridappBuildStatusEnum;
